<template>
  <ul class="product-group">
    <li class="ticket-group-list" v-for="(data, index) in products" :key="index" :class="checkedClass('group_'+productGroupNum+'_'+index)">
      <span class="product-name-box">
        <input type="radio" :id="'group_'+productGroupNum+index" name="voucher" :value="'group_'+productGroupNum+'_'+index" v-model="selectedValue" data-voucher="voucher-item" :tabindex="tabIndex('group_'+productGroupNum+'_'+index)">
        <label :for="'group_'+productGroupNum+index">
          <span class="a11y-hidden" v-if="voucherType !== 'wavve'">{{ voucherName }}</span>
          <span class="product-name">{{ isOksusu ? currentProductName :data.concurrency[0].product_name }}</span>
          <span class="product-discription">{{ productDescription(data) }}</span>
          <span v-if="rate(data) !== ''" class="tag-ticket-discount">{{rate(data)}}% 할인</span>
          <p class="product-price" :style="'color: ' + productColor + ';'">
             <span v-if="displayAmount(data) !== ''" class="sale-price">{{displayAmount(data)}}원</span>
            {{ setNumberCommas(data.concurrency[0].amount) }}원
          </p>
        </label>
      </span>
    </li>
  </ul>
</template>

<script>
import { setNumberCommas } from '@/common/utils/common'
import _ from 'lodash'
export default {
  props: {
    productUserCount: {
      type: String,
      default: '1'
    },
    products: {
      type: Array,
      required: true
    },
    productColor: {
      type: String,
      required: true,
      default: '#1351f9'
    },
    productGroupNum: {
      type: String,
      required: true
    },
    voucherType: {
      type: String,
      required: true
    },
    currentIndex: {
      type: String
    },
    isOksusu: {
      type: Boolean
    },
    currentProductName: {
      type: String
    },
    voucherName: {
      type: String
    }
  },
  data () {
    return {
      selectedValue: ''
    }
  },
  methods: {
    setNumberCommas (price) {
      return setNumberCommas(price)
    },
    checkedClass (indexInfo) {
      if (this.currentIndex === indexInfo) {
        return ' checked'
      }
    },
    tabIndex (indexInfo) {
      return this.currentIndex === indexInfo ? '0' : '-1'
    },
    productDescription (product) {
      return this.isOksusu ? product.screen_name + ' ' + product.quality_name + ' | ' + product.concurrency[0].concurrency_count + '인' : product.concurrency[0].description
    },
    rate (item) {
      return _.get(item, 'concurrency.0.discount_rate', '')
    },
    displayAmount (item) {
      return _.get(item, 'concurrency.0.displayamount', '')
    }
  },
  watch: {
    selectedValue (n, o) {
      const listIndex = this.selectedValue.split('_').pop()
      if (this.selectedValue === this.currentIndex) return
      this.$events.$emit('selectedVoucher', this.products[listIndex], this.selectedValue)
    }
  }
}
</script>
